import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Firebase yapılandırma bilgileri
const firebaseConfig = {
  apiKey: "AIzaSyAZ4L4fq0gtR6uRh6J_k8DiKcCI8UNgA_I",
  authDomain: "web-sayfam-46ff1.firebaseapp.com",
  projectId: "web-sayfam-46ff1",
  storageBucket: "web-sayfam-46ff1.firebasestorage.app",
  messagingSenderId: "504300015106",
  appId: "1:504300015106:web:6a7990ffd9eb093c52a11b",
  measurementId: "G-DP7JBPTVGV"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Veritabanını (Firestore) dışa aktar
export const db = getFirestore(app);

// Kimlik doğrulama (Auth) servisini dışa aktar
export const auth = getAuth(app);
